import React from 'react'
import "./Team.css"
const Team = () => {
  return (
    <div>
      Teams
    </div>
  )
}

export default Team
